<template>
  <div class="AInfo">
    <div class="title">
      个人信息
      <p></p>
    </div>

    <div class="formData">
      <el-form class="info-form" :rules="rules" aria-readonly="infoForm" ref="infoForm" :model="form">
        <el-form-item label="姓名：" label-width="183px" prop="name">
          <el-input v-model="form.name" placeholder="请填写姓名" :disabled="up"></el-input>
        </el-form-item>

		<el-form-item label="称谓：" label-width="183px" prop="sex" class="cw">
          <el-radio v-model="form.sex" label="0">先生</el-radio>
          <el-radio v-model="form.sex" label="1">女士</el-radio>
        </el-form-item>

        <el-form-item label="手机号码：" label-width="183px" prop="telephone">
          <el-input v-model="form.telephone" placeholder="请填写您的手机号" :disabled="up"></el-input>
        </el-form-item>

        <el-form-item label="邮箱：" label-width="183px" prop="email">
          <el-input v-model="form.email" placeholder="请填写您的邮箱" :disabled="up"></el-input>
        </el-form-item>

        <!-- <el-form-item label="学校：" label-width="183px" prop="school">
          <el-select v-model="form.school" placeholder="请选择" :disabled="up">
            <el-option
              v-for="item in schoolList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="行业：" label-width="183px" prop="industry">
          <el-select v-model="form.industry" placeholder="请选择" :disabled="up">
            <el-option
              v-for="item in industryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->

	  <el-form-item label="省份：" label-width="183px" prop="province">
          <el-select v-model="form.province" placeholder="请选择" @change="provinceChange($event,true)" :disabled="up">
            <el-option
              v-for="item in provinceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="城市：" label-width="183px" prop="city">
          <el-select v-model="form.city" placeholder="请选择" @change="cityChange" :disabled="up">
            <el-option
              v-for="item in cityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="地址：" label-width="183px">
          <el-input v-model="form.address" placeholder="请填写您的地址" :disabled="up"></el-input>
        </el-form-item>
	  
	    <el-form-item label="行业性质或学校类型：" label-width="183px"  prop="industryType">
		   <el-select v-model="form.industryType" placeholder="请选择"  @change="industryTypeChange($event,true)" class="xxxz" :disabled="up">
			 <el-option
			   v-for="item in industryTypeList"
			   :key="item.value"
			   :label="item.label"
			   :value="item.value"
			 ></el-option>
		   </el-select>
					  
		   <el-select v-model="form.industrySubtype" placeholder="请选择"  @change="industrySubtypeChange($event,true)"  class="xxxz_2"  :disabled="up">
			<el-option
			  v-for="item in industrySubtypeList"
			  :key="item.value"
			  :label="item.label"
			  :value="item.value"
			></el-option>
		   </el-select>
		  
		   <!-- <el-select v-model="form.industryGrandsontype" placeholder="请选择"  class="xxxz_3"  :disabled="up">
			<el-option
			  v-for="item in industryGrandsontypeList"
			  :key="item.value"
			  :label="item.label"
			  :value="item.value"
			></el-option>
		  </el-select> -->
				
		</el-form-item>

        <el-form-item label="单位：" label-width="183px" prop="company">
          <el-input v-model="form.company" placeholder="请填写您的单位" :disabled="up"></el-input>
        </el-form-item>
		
		<el-form-item label="职务：" label-width="183px" prop="job">
		  <el-input v-model="form.job" placeholder="请填写您的职务" :disabled="up"></el-input>
		</el-form-item>
		

        <el-form-item label="部门：" label-width="183px" prop="department">
          <el-input v-model="form.department" placeholder="请填写您的部门" :disabled="up"></el-input>
        </el-form-item>

      </el-form> 
    </div>
    <el-button @click="updateForm">{{ up ? '编辑' : '保存' }}</el-button>
  </div>
</template>
<script>
import area from "@/utils/area.js";
import industry from "@/utils/industry.js";
import { mapState } from "vuex";
export default {
  data() {
    //  邮箱校验
    let emailValidata = (rule, value, callback) => {
      let emailTest = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!emailTest.test(value)) {
        callback(new Error("请输入正确的邮箱!"));
      } else {
        callback();
      }
    };

    //手机号校验规则
    let mobileValidata = (rule, value, callback) => {
      let testStr = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!testStr.test(value)) {
        callback(new Error("请输入正确的手机号码!"));
      } else {
        callback();
      }
    };

    return {
      up: true,
      form: {
        id: "",
        name: "", // 姓名
        job: "", // 职位
        telephone: "", // 手机号
        email: "", // 邮箱
        school: "", // 学校
        industry: "", // 行业
        company: "", // 单位
        sex: "0",
        department: "", // 部门
        province: "", // 省
        city: "", // 市
        address: "", // 地址
		industryType: "",
		industrySubtype: "",
		industryGrandsontype: "",
		
        problem1: [],
        problem2: "",
        problem3: "",
        problem4: [],
        cType_qit1: "",
        cType_qit3: "",
        cType_qit4: ""
      },
      provinceList: [], // 省
      cityList: [], // 市
	  industryTypeList:[],
	  industrySubtypeList:[],
	  industryGrandsontypeList:[],
      // 学校list
      schoolList: [
        {
          value: "高教",
          label: "高教"
        },
        {
          value: "普教",
          label: "普教"
        },
        {
          value: "幼教",
          label: "幼教"
        },
        {
          value: "职教",
          label: "职教"
        }
      ],
      // 行业list
      industryList: [
        {
          value: "生产商",
          label: "生产商"
        },
        {
          value: "经销商",
          label: "经销商"
        },
        {
          value: "集成商",
          label: "集成商"
        },
        {
          value: "品牌商",
          label: "品牌商"
        },
        {
          value: "代理商",
          label: "代理商"
        },
        {
          value: "采购商",
          label: "采购商"
        },
        {
          value: "出版商",
          label: "出版商"
        },
        {
          value: "教育机构",
          label: "教育机构"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      rules: {
        name: [{ required: true, message: "*为必填项", trigger: "blur" }], // validator 校验规则
        telephone: [
          {
            required: true,
            validator: mobileValidata,
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            validator: emailValidata,
            trigger: "blur"
          }
        ],
        school: [{ required: true, message: "*为必填项", trigger: "change" }],
        industry: [{ required: true, message: "*为必填项", trigger: "change" }],
        company: [{ required: true, message: "*为必填项", trigger: "blur" }],
        sex: [{ required: true, message: "*为必填项", trigger: "blur" }],
        job: [{ required: true, message: "*为必填项", trigger: "blur" }],
        department: [{ required: true, message: "*为必填项", trigger: "blur" }],
        province: [{ required: true, message: "*为必填项", trigger: "change" }],
        city: [{ required: true, message: "*为必填项", trigger: "change" }],
		industryType: [{ required: true, message: "*为必填项", trigger: "change" }],
        problem1: [
          {
            required: true,
            message: "*为必填项",
            trigger: "change"
          }
        ],
        problem2: [{ required: true, message: "*为必填项", trigger: "change" }],
        problem3: [{ required: true, message: "*为必填项", trigger: "change" }],
        problem4: [
          {
            required: true,
            message: "*为必填项",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: mapState({
    name: state => state.GZUserInfo.name, //姓名
    telephone: state => state.GZUserInfo.telephone, // 手机
    email: state => state.GZUserInfo.email, // 邮箱
    school: state => state.GZUserInfo.school, // 学校
    industry: state => state.GZUserInfo.industry, // 行业
    company: state => state.GZUserInfo.company, // 单位
    department: state => state.GZUserInfo.department, // 部门
    sex: state => state.GZUserInfo.sex, // 称谓
    province: state => state.GZUserInfo.province, // 省
    city: state => state.GZUserInfo.city, // 市
    address: state => state.GZUserInfo.address, // 邮箱
	job: state => state.GZUserInfo.job, 
	industryType: state => state.GZUserInfo.industryType, 
	industrySubtype: state => state.GZUserInfo.industrySubtype, 
	industryGrandsontype: state => state.GZUserInfo.industryGrandsontype
  }),
  mounted() {
    this.init();
    this.provinceHandle();
    this.getEventInfo();
  },
  methods: {
    // 初始化
    init() {},
    // 省份处理
    provinceHandle() {
      let proArr = [];
      area.forEach((ele, index) => {
        proArr[index] = {
          label: ele.name,
          value: ele.name
        };
      });
      this.provinceList = proArr;
    },

    // 省份
    provinceChange(val, notInit) {
      let cityArr = area.filter(res => {
        return res.name === val;
      });
      let arr = [];
      cityArr[0].cities.forEach((ele, index) => {
        arr[index] = {
          label: ele.name,
          value: ele.name
        };
      });
      this.cityList = arr;
	 
	  notInit? (this.form.city = arr[0].label):'';
	  
    },
    // 城市
    cityChange(val) {
    },
	
	//行业
	industryHandle(val, notInit){
		if(val != ''){
			let industryTypeArr = [];
			industry.forEach((ele, index) => {
			  industryTypeArr[index] = {
			    label: ele.name,
			    value: ele.name,
			  };
			});
			this.industryTypeList = industryTypeArr;
			this.form.industryType = val;
			this.industryTypeChange(val, notInit);
		}
	},
	
	//一级----industry.filter一级改变获取二级值
	industryTypeChange(val, notInit) {
	  let industrySubtypeArr = industry.filter((res) => {
	    return res.name === val;
	  });
	  
	  let arr = [];
	  if(industrySubtypeArr!=''){
		  industrySubtypeArr[0].level11s.forEach((ele, index) => {
		    arr[index] = {
		      label: ele.name,
		      value: ele.name,
		    };
		  });
		  this.industrySubtypeList = arr;
		  
		  notInit?(this.form.industrySubtype = arr[0].label,
		  this.industrySubtypeChange(arr[0].label, notInit)):'';
		  
	  }
	  
	},
	
	//二级
	industrySubtypeChange(val, notInit) {
	  //获取第三级的值	
	  let industryGrandsontypeArr = [];
	  industry.forEach((res, index) => {
		res.level11s.forEach((ele, index) => {
		   if(ele.name === val){
			  industryGrandsontypeArr = ele.level111s;
		   }	
		});
	  });
	  
	  let arr = [];
	  if(industryGrandsontypeArr.length>0){
		  industryGrandsontypeArr.forEach((ele, index) => {
		    arr[index] = {
		      label: ele.name,
		      value: ele.name,
		    };
		  });
		  
		  notInit?(this.form.industryGrandsontype = arr[0].label):'';
	  }else{
		  this.form.industryGrandsontype = '';
	  }
	   this.industryGrandsontypeList = arr;
	},

    updateForm() {
      if (this.up) {
        this.up = false;
      } else {
        this.$refs["infoForm"].validate( (valid) => {
          if (valid) {
            this.$http({
              url: "viewer/updateViewer",
              method: "post",
              data: this.$http.adornData({
                id: this.form.id,
                name: this.form.name, // 姓名
                telephone: this.form.telephone,
                email: this.form.email, // 邮箱
                job: this.form.pJob, // 职位
                school: this.form.school,
                industry: this.form.industry, // 行业
                company: this.form.company, // 单位
                sex: this.form.sex,
                department: this.form.department, // 部门
                province: this.form.province, // 省份
                city: this.form.city, // 市
                address: this.form.address, // 地址
				job: this.form.job,
				industryType: this.form.industryType, 
				industrySubtype: this.form.industrySubtype, 
				industryGrandsontype: this.form.industryGrandsontype
              })
            }).then(({ data }) => {
              let { code } = data;
              if (code === 0) {
                this.$message({
                  message: "信息修改成功！",
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.getEventInfo();
                    this.up = true;
                  }
                });
              } else {
                this.$message.error("修改失败，请稍后重试！")
              }
            }).catch( err => console.log(err))
          }
        });
      }
    },

    // 个人信息
    getEventInfo() {
      this.$http({
        url: "viewer/viewerInfo",
        method: "get"
      }).then(({ data }) => {
        let { code, user } = data;
        if (code === 0 && user) {
          this.form.id = user.id,
          this.form.name = user.name;
          this.form.telephone = user.telephone;
          this.form.email = user.email;
          this.form.school = user.school;
          this.form.industry = user.industry;
          this.form.company = user.company;
          this.form.department = user.department;
          this.form.sex = user.sex;
          this.form.province = user.province;
          this.form.city = user.city;
          this.form.address = user.address;
		  this.form.job = user.job;
		  this.form.industryType = user.industryType;
		  this.form.industrySubtype = user.industrySubtype;
		  this.form.industryGrandsontype = user.industryGrandsontype;
		  this.provinceChange(user.province,false);
		  this.industryHandle(user.industryType, false);
        } else {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/audLogin");
        }
      });
    }
  }
};
</script>
<style lang="scss">
.AInfo {
  .el-input__inner {
    width: 624px;
    height: 42px;
    border-radius: 4px;
  }
  .el-input--suffix .el-input__inner {
    width: 220px;
  }
  .el-radio {
    width: 95px;
  }
  .el-radio__inner {
    &:hover {
      border-color: #143372;
    }
  }
  .el-radio__input .el-radio__inner {
    width: 20px;
    height: 20px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    width: 20px;
    height: 20px;
    background-color: #ffffff;
    border: 2px solid #dcdfe6;
    border-color: #143372;
  }
  .el-radio__inner::after {
    width: 12px;
    height: 12px;
    background-color: #143372;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #333333;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before {
    margin-right: 10px;
  }
  
  .xxxz {
	width: 245px;
	margin-right: 8px;
   .el-input--suffix .el-input__inner {
	  width: 245px;
    }
  }
  .xxxz_2 {
	  width: 210px;
	  margin-right: 8px;
	  .el-input--suffix .el-input__inner {
		width: 210px;
	  }
  }
  .xxxz_3 {
  	  width: 150px;
  	  .el-input--suffix .el-input__inner {
  		width: 150px;
  	  }
  }
}
</style>
<style lang="scss" scoped>
.AInfo {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 10px;
    p {
      width: 70px;
      height: 2px;
      background-color: #143372;
      position: absolute;
      bottom: -1px;
      left: 30px;
    }
  }
  .info-form {
    padding: 50px 115px 0 0;
  }
  .el-button {
    width: 220px;
    height: 52px;
    background-color: #143372;
    font-size: 18px;
    color: #ffffff;
    margin: 48px 0 69px 183px;
  }
}
</style>